<app-material [material]="false">
    <div class="header" header>
        <h2>{{ "admin.toolMaintenancePlans.plans.title" | translate }}</h2>
        <app-button type="primary" class="add-button" (click)="openModal()">
            {{ "admin.toolMaintenancePlans.plans.add" | translate }}
        </app-button>
    </div>
    <ng-container body>
        <app-maintenance-plans-table class="plans-table"
                                     [maintenancePlans]="plans"
                                     [isLoading]="loadingPlans$ | async"
                                     [tableConfig]="tableConfig"
                                     [headerBackgroundColor]="'rgba(162,186,210, .3)'"
                                     (pageChange)="onPageChange()"
                                     (sortChange)="onSortChange()"
                                     (filterChange)="onFilter()"
                                     (rowClick)="onSelectPlan($event)"
                                     (openNewPage)="onOpenNewPage($event)">
        </app-maintenance-plans-table>
    </ng-container>
</app-material>

<app-maintenance-plan-modal (submit)="onSubmit($event)"
></app-maintenance-plan-modal>
